/** Client unique : demande intacte, reponses expliquees et requetes perimees annulees. */
(function () {
  'use strict';
  var configEl = document.getElementById('recherche-config');
  if (!configEl) return;
  var cfg;
  try { cfg = JSON.parse(configEl.textContent); } catch (_) { return; }
  var lang = cfg.locale.toLowerCase().startsWith('pt') ? 'pt-PT' : cfg.locale.split('-')[0];
  var params = new URLSearchParams(location.search);
  var country = params.get('search_country') || cfg.country;
  var copyPromise = fetch(cfg.copyUrl, { signal: AbortSignal.timeout(12000) }).then(function (r) {
    if (!r.ok) throw Error('copy'); return r.json();
  }).then(function (all) { if (!all[lang]) throw Error('locale'); return all[lang]; });
  // Les formulaires partent immediatement avec les mots saisis, meme si la copie se charge encore.
  function url(q, extra) {
    var p = new URLSearchParams({ q: q, search_country: country });
    Object.keys(extra || {}).forEach(function (k) { if (extra[k] != null) p.set(k, String(extra[k])); });
    return cfg.searchUrl + '?' + p.toString();
  }
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f.matches('form[action*="/search"]')) return;
    var input = f.querySelector('input[name="q"]');
    if (!input) return;
    e.preventDefault(); location.href = url(input.value.trim());
  });
  var raw = params.get('saisie') || params.get('q') || '';
  document.querySelectorAll('form[action*="/search"] input[name="q"]').forEach(function (input) { if (location.pathname.endsWith('/search')) input.value = raw; });
  function esc(value) { return String(value == null ? '' : value).replace(/[&<>"']/g, function (c) { return ({ '&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;', "'":'&#39;' })[c]; }); }
  function safe(value) {
    if (!value) return '';
    try { var u = new URL(value, location.origin); return u.protocol === 'https:' && (u.hostname === 'affichely.com' || u.hostname === 'www.affichely.com' || u.hostname === 'cdn.shopify.com') ? u.href : ''; } catch (_) { return ''; }
  }
  function t(copy, key, values) { var out = copy[key] || key; Object.keys(values || {}).forEach(function (k) { out = out.replaceAll('{' + k + '}', values[k]); }); return out; }
  function money(price) { try { return new Intl.NumberFormat(cfg.locale, { style:'currency', currency:price.currencyCode }).format(Number(price.amount)); } catch (_) { return price.amount + ' ' + price.currencyCode; } }
  function missing(p, copy) { return t(copy, 'missing', { terms:p.manque.map(function (m) { return m.source === 'supportFormat' ? copy.supportFormat : m.source; }).filter(function (v, i, a) { return a.indexOf(v) === i; }).join(', ') }); }
  function product(p, copy, small) {
    var href = safe(p.url); if (!href) return '';
    var src = p.image && safe(p.image.url), image = src ? '<img src="' + esc(src + (src.includes('?') ? '&' : '?') + 'width=' + (small ? 110 : 600)) + '" alt="" width="' + (small ? 44 : 480) + '" height="' + (small ? 58 : 600) + '" ' + (small ? '' : 'loading="lazy" ') + 'decoding="async">' : '';
    var note = p.manque.length ? '<span class="rs-missing">' + esc(missing(p, copy)) + '</span>' : '';
    var artist = p.artiste ? '<span class="rs-artist">' + esc(p.artiste) + '</span>' : '';
    if (small) return '<a class="sug__item" data-rs-id="' + esc(p.id) + '" href="' + esc(href) + '"><span class="sug__thumb">' + image + '</span><span class="sug__t">' + esc(p.title) + artist + note + '</span><span class="sug__p">' + esc(money(p.price)) + '</span></a>';
    return '<article class="rs-card"><a data-rs-id="' + esc(p.id) + '" href="' + esc(href) + '"><figure>' + image + '</figure><h3>' + esc(p.title) + '</h3>' + artist + '<p>' + esc(copy.from) + ' ' + esc(money(p.price)) + '</p></a>' + (note ? '<p>' + note + '</p>' : '') + '</article>';
  }
  function choices(r, copy, initial) {
    return (r.ambigus || []).map(function (a) {
      return '<p>' + esc(t(copy, 'unresolved', { terms:a.source })) + '</p>' + a.options.map(function (o) {
        var selected = Object.assign({}, initial); selected[a.id] = o.id;
        return '<a class="rs-choice" href="' + esc(url(r.demande.raw, { choix:JSON.stringify(selected) })) + '">' + esc(o.label) + '</a>';
      }).join('');
    }).join('');
  }
  function help(r, copy) {
    return r.aide.map(function (key) { var href = safe(cfg.help[key]); return href ? '<a class="rs-choice" href="' + esc(href) + '">' + esc(copy[key]) + '</a>' : ''; }).join('');
  }
  function collections(r, copy) {
    return (r.rayons || []).length ? '<div class="rs-choices"><h2 class="sug__head">' + esc(copy.collections) + '</h2>' + r.rayons.map(function (c) {
      return '<a class="rs-choice" href="' + esc(safe(c.url)) + '">' + esc(c.title) + '</a>';
    }).join('') + '</div>' : '';
  }
  function artists(r, copy) {
    var rows = (r.artistes || []).map(function (artist) {
      var href = new URL(cfg.searchUrl, location.origin);
      href.pathname = href.pathname.replace(/\/search\/?$/, '/collections/vendors');
      href.search = ''; href.searchParams.set('q', artist.nom);
      return '<a class="rs-choice rs-artist-link" href="' + esc(safe(href.href)) + '">' + esc(artist.nom) + '</a>';
    }).join('');
    return rows ? '<div class="rs-choices">' + (copy.artists ? '<h2 class="sug__head">' + esc(copy.artists) + '</h2>' : '') + rows + '</div>' : '';
  }
  function suggestions(r, copy) {
    return r.propositions.length ? '<div class="rs-choices"><p>' + esc(copy.suggestion) + '</p>' + r.propositions.map(function (q) { return '<a class="rs-choice" href="' + esc(url(q)) + '">' + esc(q) + '</a>'; }).join('') + '</div>' : '';
  }
  function event(r, values) {
    if (!r.requestId) return;
    fetch(cfg.endpoint + '/evenement', { method:'POST', mode:'cors', credentials:'omit', keepalive:true,
      headers:{'Content-Type':'application/json'}, body:JSON.stringify(Object.assign({ requestId:r.requestId }, values)), signal:AbortSignal.timeout(8000) }).catch(function () {});
  }
  function observe(box, r, links) {
    if (!links && box.rsObserver) box.rsObserver.disconnect();
    links = links || box.querySelectorAll('[data-rs-id]');
    links.forEach(function (a) { a.addEventListener('click', function () { event(r, { clic:a.dataset.rsId }); }); });
    var vus = new Set(), delay;
    event(r, { affiches:[] });
    if (typeof IntersectionObserver !== 'function') return function () {};
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) { if (entry.isIntersecting) vus.add(entry.target.dataset.rsId); });
      clearTimeout(delay); delay = setTimeout(function () { event(r, { affiches:Array.from(vus) }); }, 150);
    }, { threshold:0.1 });
    links.forEach(function (a) { observer.observe(a); });
    box.rsObserver = observer;
    return function () { observer.disconnect(); clearTimeout(delay); };
  }
  function query(q, source, controller, extra) {
    var p = new URLSearchParams(Object.assign({ q:q, locale:lang, country:country, source:source, path:url(q, extra) }, extra));
    var timeout;
    // La borne couvre aussi le corps JSON et reste effective si le transport tarde a s'annuler.
    return Promise.race([
      fetch(cfg.endpoint + '?' + p.toString(), { mode:'cors', credentials:'omit', signal:controller.signal }).then(function (r) { if (!r.ok) throw Error('http_' + r.status); return r.json(); }),
      new Promise(function (_, reject) { timeout = setTimeout(function () { reject(Error('recherche_delai')); controller.abort(); }, extra && extra.comptage ? 45000 : source === 'barre' ? 8000 : 12000); })
    ]).finally(function () { clearTimeout(timeout); });
  }
  function initialise(copy) {
    var header = document.querySelector('[data-search]');
    if (header) initHeader(header, copy);
    var page = document.querySelector('[data-recherche-v2]');
    if (page) initPage(page, copy);
  }
  function initHeader(box, copy) {
    var input = box.querySelector('[data-search-input]'), panel = box.querySelector('[data-search-panel]'), results = box.querySelector('[data-search-results]'), clear = box.querySelector('[data-search-clear]');
    if (!input || !panel || !results) return;
    var seq = 0, timer, controller, selected = -1, popular = null;
    results.classList.add('rs-suggest'); results.id = 'recherche-suggestions'; results.setAttribute('role', 'listbox');
    input.setAttribute('role', 'combobox'); input.setAttribute('aria-controls', results.id); input.setAttribute('aria-expanded', 'false'); input.setAttribute('aria-autocomplete', 'list');
    function cancel() { seq++; clearTimeout(timer); if (controller) controller.abort(); selected = -1; input.removeAttribute('aria-activedescendant'); }
    function open(html) { panel.hidden = false; results.innerHTML = html; box.classList.add('is-sug-open'); input.setAttribute('aria-expanded', 'true'); selected = -1;
      results.querySelectorAll('a').forEach(function (a, i) { a.id = 'rs-option-' + i; a.setAttribute('role', 'option'); a.setAttribute('aria-selected', 'false'); }); }
    function close() { cancel(); panel.hidden = true; box.classList.remove('is-sug-open'); input.setAttribute('aria-expanded', 'false'); }
    function empty() {
      var rows = (window.MURMURE_SEARCH_BROWSE || []).map(function (r) { return '<a class="sug__vig" href="' + esc(safe(r.u)) + '"><img src="' + esc(safe(r.i)) + '" alt="" width="210" height="150"><span>' + esc(r.t) + '</span></a>'; }).join('');
      var motsPopulaires = popular;
      var motsAffiches = motsPopulaires && motsPopulaires.length ? motsPopulaires : (window.MURMURE_SEARCH_CHIPS || []).map(function (x) { return x.q; });
      var chips = motsAffiches.map(function (q) { return '<a class="rs-choice" href="' + esc(url(q)) + '">' + esc(q) + '</a>'; }).join('');
      open('<div class="rs-notice">' + esc(copy.empty) + '</div><div class="rs-choices">' + chips + '</div><div class="sug__browse">' + rows + '</div>');
      if (popular === null) {
        popular = [];
        fetch('https://runway.dcomdtf.app/search-log/populaires?n=6&locale=' + encodeURIComponent(lang), { signal:AbortSignal.timeout(3000) }).then(function (r) { if (!r.ok) throw Error('popular'); return r.json(); }).then(function (r) { popular = r.mots || []; if (!input.value && !panel.hidden) empty(); }).catch(function () {});
      }
    }
    function run() {
      cancel(); var token = seq, q = input.value.trim(); if (clear) clear.hidden = !q;
      if (!q) { empty(); return; }
      open('<div class="rs-notice" role="status">' + esc(copy.loading) + '</div>');
      timer = setTimeout(function () {
        controller = new AbortController(); var active = controller;
        query(q, 'barre', active, {apercu:'1'}).then(function (r) {
          if (token !== seq || input.value.trim() !== q) return;
          var html = '';
          if (r.etat === 'aide') html = '<div class="rs-choices"><p>' + esc(copy.help) + '</p>' + help(r, copy) + '</div>';
          else if (r.etat === 'ambigu') html = '<div class="rs-choices">' + choices(r, copy, {}) + '</div>';
          else {
            html += r.complets.length ? '<div class="sug__head">' + esc(copy.exact) + '</div>' + r.complets.map(function (p) { return product(p, copy, true); }).join('') : '<div class="rs-notice">' + esc(copy.none) + '</div>';
            if (r.partiels.length) html += '<div class="sug__head">' + esc(copy.partial) + '</div>' + r.partiels.slice(0, 3).map(function (p) { return product(p, copy, true); }).join('');
            html = artists(r, copy) + html + collections(r, copy) + suggestions(r, copy);
          }
          html += '<a class="sug__all" href="' + esc(url(q)) + '">' + esc(copy.all) + ' →</a>';
          open(html); observe(results, r);
        }).catch(function () {
          if (token !== seq) return;
          open('<div class="rs-notice" role="status">' + esc(copy.error) + '</div><div class="rs-choices"><button type="button" class="rs-action" data-rs-retry>' + esc(copy.retry) + '</button></div><a class="sug__all" href="' + esc(url(q)) + '">' + esc(copy.all) + ' →</a>');
          results.querySelector('[data-rs-retry]').addEventListener('click', run);
        });
      }, 250);
    }
    input.addEventListener('input', run);
    input.addEventListener('focus', run);
    input.addEventListener('click', function () { if (panel.hidden) run(); });
    if (clear) clear.addEventListener('click', function () { cancel(); input.value = ''; clear.hidden = true; input.focus(); empty(); });
    input.addEventListener('keydown', function (e) {
      // Le champ search natif efface sinon la saisie puis emet input, qui rouvrirait le panneau.
      if (e.key === 'Escape') { e.preventDefault(); close(); return; }
      var items = Array.from(results.querySelectorAll('a')); if (panel.hidden || !items.length) return;
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault(); selected = (selected + (e.key === 'ArrowDown' ? 1 : -1) + items.length) % items.length;
        items.forEach(function (a, i) { a.setAttribute('aria-selected', String(i === selected)); }); input.setAttribute('aria-activedescendant', items[selected].id); items[selected].scrollIntoView({ block:'nearest' });
      } else if (e.key === 'Enter' && selected >= 0) { e.preventDefault(); items[selected].click(); }
    });
    document.addEventListener('click', function (e) { if (!e.composedPath().includes(box)) close(); });
    if (document.activeElement === input) run();
  }
  function initPage(box, copy) {
    var target = box.querySelector('[data-rs-results]'), status = box.querySelector('[data-rs-status]'), heading = box.querySelector('h1');
    heading.textContent = raw ? t(copy, 'title', { query:raw }) : copy.empty;
    document.title = heading.textContent + ' | Affichely';
    var extra = { page:params.get('page') || '1', groupe:params.get('groupe') || 'complets' };
    if (params.get('choix')) extra.choix = params.get('choix');
    var selected = {}; try { selected = JSON.parse(extra.choix || '{}'); } catch (_) {}
    var controllers = [], tracking = [], sentinel, generation = 0;
    function stop() {
      generation++;
      controllers.forEach(function (c) { c.abort(); }); controllers = [];
      tracking.forEach(function (disconnect) { disconnect(); }); tracking = [];
      if (sentinel) sentinel.disconnect();
      sentinel = null;
    }
    window.addEventListener('pagehide', function (e) { if (!e.persisted) stop(); });
    function run() {
      stop(); var token = generation;
      status.textContent = copy.loading; target.innerHTML = ''; box.setAttribute('aria-busy', 'true');
      function request(options) {
        var controller = new AbortController(); controllers.push(controller);
        return query(raw, 'page', controller, Object.assign({}, extra, options));
      }
      function render(r) {
        var html = '', group = r.groupe || extra.groupe;
        var state = { page:Number(r.page) || 1, next:!!r.hasNext || r.page < r.pages, busy:false, failed:false, seen:new Set() };
        if (r.etat === 'vide') html = '<p>' + esc(copy.empty) + '</p>';
        else if (r.etat === 'aide') html = '<div class="rs-notice"><h2>' + esc(copy.help) + '</h2>' + help(r, copy) + '</div>';
        else if (r.etat === 'ambigu') html = '<div class="rs-notice"><h2>' + esc(copy.ambiguous) + '</h2>' + choices(r, copy, selected) + '</div>';
        else {
          if (r.demande.corrections.length) html += '<p class="rs-meta">' + esc(t(copy, 'corrected', { terms:r.demande.corrections.map(function (c) { return c.source + ' → ' + c.propositions.join(' / '); }).join(', ') })) + '</p>';
          html += '<section class="rs-group" data-rs-primary' + (r[group].length ? '' : ' hidden') + '><h2>' + (r[group].length ? esc(group === 'partiels' ? copy.partial : copy.exact) : '') + '</h2><p class="rs-meta" data-rs-count></p><div class="rs-grid" data-rs-grid></div></section>';
          if (!r.complets.length && group === 'complets') html += '<p class="rs-notice">' + esc(copy.none) + '</p>';
          html += '<nav class="rs-pagination" data-rs-pagination>' + (state.page > 1 ? '<a class="rs-choice" href="' + esc(url(raw, Object.assign({}, extra, { page:state.page - 1 }))) + '">' + esc(copy.previous) + '</a>' : '') + '<a class="rs-choice" data-rs-more href="' + esc(url(raw, Object.assign({}, extra, { page:state.page + 1 }))) + '">' + esc(copy.more || copy.next) + '</a><p class="rs-meta" role="status" data-rs-more-status></p></nav><div data-rs-alternatives></div>';
          html = artists(r, copy) + html + collections(r, copy) + suggestions(r, copy);
        }
        target.innerHTML = html;
        var grid = target.querySelector('[data-rs-grid]'), pager = target.querySelector('[data-rs-pagination]');
        var more = target.querySelector('[data-rs-more]'), progress = target.querySelector('[data-rs-more-status]');
        function counts(result) {
          var count = group === 'partiels' ? result.totalPartiels : result.total;
          var text = count == null || ['aide', 'ambigu', 'vide'].includes(result.etat) ? '' : t(copy, 'count', { count:count });
          status.textContent = text;
          var label = target.querySelector('[data-rs-count]'); if (label) label.textContent = text;
        }
        function append(result) {
          var fragment = document.createElement('template');
          fragment.innerHTML = result[group].filter(function (p) {
            if (state.seen.has(p.id)) return false;
            state.seen.add(p.id); return true;
          }).map(function (p) { return product(p, copy, false); }).join('');
          var links = Array.from(fragment.content.querySelectorAll('[data-rs-id]'));
          grid.appendChild(fragment.content);
          tracking.push(observe(target, result, links));
        }
        function alternatives(result) {
          var preview = target.querySelector('[data-rs-alternatives]');
          if (group !== 'complets' || !preview || preview.children.length || !result.partiels.length) return;
          preview.innerHTML = '<section class="rs-group rs-group--partial"><h2>' + esc(copy.partial) + '</h2><div class="rs-grid">' + result.partiels.map(function (p) { return product(p, copy, false); }).join('') + '</div>' + (result.totalPartiels == null || result.totalPartiels > result.partiels.length ? '<a class="rs-choice" href="' + esc(url(raw, { groupe:'partiels', choix:extra.choix })) + '">' + esc(copy.all) + '</a>' : '') + '</section>';
          tracking.push(observe(preview, result));
        }
        function updateMore() {
          more.hidden = !state.next;
          more.href = url(raw, Object.assign({}, extra, { groupe:group, page:state.page + 1 }));
          more.setAttribute('aria-disabled', String(state.busy));
          more.textContent = state.failed ? copy.retry : copy.more || copy.next;
          progress.textContent = state.busy ? copy.loading : state.failed ? copy.error : state.seen.size ? t(copy, 'shown', { count:state.seen.size }) : '';
          grid.setAttribute('aria-busy', String(state.busy));
          if (sentinel) {
            sentinel.disconnect();
            if (state.next && !state.busy && !state.failed) sentinel.observe(pager);
          }
        }
        function loadMore() {
          if (!state.next || state.busy || token !== generation) return;
          state.busy = true; state.failed = false; updateMore();
          var nextPage = state.page + 1;
          request({ page:nextPage, groupe:group, apercu:'1' }).then(function (result) {
            if (token !== generation) return;
            if (result.page !== nextPage || result.groupe !== group) throw Error('recherche_page_inattendue');
            append(result); alternatives(result);
            if ((group === 'partiels' ? result.totalPartiels : result.total) != null) counts(result);
            state.page = nextPage; state.next = !!result.hasNext || result.page < result.pages;
          }).catch(function () {
            if (token === generation) state.failed = true;
          }).finally(function () {
            if (token === generation) { state.busy = false; updateMore(); }
          });
        }
        counts(r);
        if (!grid) return;
        append(r); alternatives(r);
        if ('IntersectionObserver' in window) sentinel = new IntersectionObserver(function (entries) {
          if (!state.failed && entries.some(function (entry) { return entry.isIntersecting; })) loadMore();
        }, { rootMargin:'600px 0px' });
        more.addEventListener('click', function (e) {
          if (e.ctrlKey || e.metaKey || e.shiftKey || e.altKey) return;
          e.preventDefault(); loadMore();
        });
        updateMore();
        if (r.comptageComplet === false) request({ comptage:'1', requestId:r.requestId || '' }).then(function (result) {
          if (token !== generation) return;
          counts(result); alternatives(result);
        }).catch(function () {});
      }
      request({ apercu:'1' }).then(function (r) {
        if (token === generation) render(r);
      }).catch(function () {
        if (token !== generation) return;
        status.textContent = copy.error; target.innerHTML = '<button type="button" class="rs-action" data-rs-retry>' + esc(copy.retry) + '</button>'; target.querySelector('button').addEventListener('click', run);
      }).finally(function () { if (token === generation) box.setAttribute('aria-busy', 'false'); });
    }
    run();
  }
  copyPromise.then(initialise).catch(function () {
    // Le message de secours est rendu par Liquid dans la langue du visiteur.
    document.querySelectorAll('[data-rs-resource-error]').forEach(function (el) { el.hidden = false; });
    document.querySelectorAll('[data-rs-status]').forEach(function (el) { el.textContent = ''; });
  });
}());
